import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-SharedSpecificLead" */'shared-components/components/SpecificLead'));
